import { createContext, useContext, useState } from "react";

const SettingsContext = createContext();

const SettingsContextProvider = ({ children }) => {

    const [settingsContext, setSettingsContext] = useState();

    return (
        <SettingsContext.Provider value={{
            settingsContext, setSettingsContext
        }}>
            {children}
        </SettingsContext.Provider>
    )
}

export default SettingsContextProvider;

export const useSettingsContext = () => {
    return useContext(SettingsContext);
}